import DataInvoice from "./DataInvoice";

export default function DataWaitingInvoice({ row, index, onChecked }) {
  return (
    <DataInvoice
      row={row}
      index={index}
      active="waiting"
      onChecked={onChecked}
    />
  );
}
